export enum WorkTypeStatus {
  ACTIVE = 0,
  INACTIVE = 10,
  DEPRECATED = 20,
}
